/*
 * Copyright (c) 2022
 * 
 * Created Date: Tuesday, October 4th 2022, 11:51:42 am
 * Author: Muhammad Fajariansyah Ismail
 * 
 */

import { useEffect, useRef } from "react"
import { MdClear } from "react-icons/md"
import Swal from "sweetalert2"
import QrScanner from 'qr-scanner';

const ScanQRCode = ({ onQRScanned }) => {

    const videoRef = useRef();
    const qrScannerRef = useRef();

    const onQrResult = (result, error) => {

        if (result) {
            onQRScanned(result?.text, false)
        }

        if (error) {
            onQRScanned(null, error)
        }
    }

    useEffect(()=>{
        qrScannerRef.current = new QrScanner(
            videoRef.current,
            result => {
                onQRScanned(result.data, false)
                qrScannerRef.current.stop();
            },
            {
                maxScansPerSecond: 10,
                highlightCodeOutline: true,
                highlightScanRegion: true
            },
        );

        qrScannerRef.current.start();
        return () => {
            qrScannerRef.current.stop();
        }
    },[])

    console.log('load')
    return (
        <div className="luna-alert-content-container scan-qr-code">
            <div className="icon-close" onClick={Swal.close}>
                <MdClear />
            </div>
            <h5>Scan QR Code</h5>
            <div className="camera-wrapper">
                <video ref={videoRef} />
            </div>
            <p>Face you camera to QR Code to record your attendance</p>
        </div>
    )
}

export default ScanQRCode
